// extracted by mini-css-extract-plugin
module.exports = {"buttonXxsNeutral":"ButtonXxsNeutral_buttonXxsNeutral__1_KUq"};